/**
 * Shop checkout script - display and hiding steps
 */
class MM_shopCheckout {
    constructor() {
        this.initState();
        this.initEvents();
    }

    initState() {
        this.checkoutPage = $('body.woocommerce-checkout');
        
        if (this.checkoutPage.length) {
            this.checkoutWrapper = this.checkoutPage.find('.woocommerce');
            this.checkoutForm = this.checkoutWrapper.find('.woocommerce-checkout');
            this.fastShoppingBtn = this.checkoutWrapper.find('.fast-shopping');
            this.checkoutGridFirstCol = this.checkoutForm.find('#customer_details');
            this.checkoutGridSecondCol = this.checkoutForm.find('.woocommerce-checkout-review-order');
            this.nexBtnFirstCol = this.checkoutGridFirstCol.find('.continue-btn');
            this.backBtnToStep1 = this.checkoutForm.find('.back-to-step-1');
            this.backBtnToStep2 = this.checkoutForm.find('.back-to-step-2');
            this.nexBtnSecondCol = this.checkoutForm.find('.next-btn');

            this.formFieldWrapper = this.checkoutForm.find('.woocommerce-billing-fields__field-wrapper');
            this.postCode = this.formFieldWrapper.find('#billing_postcode');
            this.phone = this.formFieldWrapper.find('#billing_phone');

            this.shippingMethod = $('#shipping_method');
            this.paymentMethods = $('.payment_methods');
            this.courierOnDelivery = this.shippingMethod.find('input[value="flexible_shipping_7_4"]');
            this.inpostOnDelivery = this.shippingMethod.find('input[value="flexible_shipping_12_6"]');
            this.cashOnDelivery = this.paymentMethods.find('#payment_method_cod');
            this.payUInput = this.paymentMethods.find('#payment_method_payustandard');
        }
    }

    initEvents() {
        if (!this.checkoutPage.length) {
            return;
        }

        this.initGTM();
        this.postCode.mask('00-000');
        this.phone.mask('000000000000000');

        this.fastShoppingBtn.on('click', e => {
            e.preventDefault();
            this.checkoutWrapper.addClass('checkout-step-1');
            this.checkoutForm.css('display', 'block');
            this.checkoutForm.addClass('is-active');
            this.checkoutGridFirstCol.addClass('is-active');
        });

        this.nexBtnSecondCol.on('click', e => {
            e.preventDefault();
            this.checkoutGridSecondCol.removeClass('is-step-2');
            this.checkoutGridSecondCol.addClass('is-step-3');

            let wrapper = $('#payment');
            let hook = wrapper.find('.summary-table');
            let oldData = wrapper.find('.summary-data');
            
            if (oldData.length) {
                oldData.remove();
            }

            let output = this.generateSummary();
            output.insertBefore(hook);
        });

        this.backBtnToStep1.on('click', e => {
            e.preventDefault();
            this.checkoutGridFirstCol.removeClass('is-hidden');
            this.checkoutGridSecondCol.removeClass('is-step-2');
        });

        if(this.courierOnDelivery.attr('checked') === 'checked') {
            console.log('courierDelivery checked');
            $('input[name="payment_method"]').attr('checked', '');
            this.cashOnDelivery.attr('checked', 'checked');
            this.payUInput.addClass('disabled');
        } else {
            this.payUInput.removeClass('disabled');
        }
        
        this.inpostOnDelivery.on('input', () => {
            console.log('inpostDelivery checked');
            this.payUInput.toggleClass('disabled');
        });

        this.formName = this.checkoutForm.find('#billing_first_name');
        this.formLastName = this.checkoutForm.find('#billing_last_name');
        this.formAddress = this.checkoutForm.find('#billing_address_1');
        this.formPostCode = this.checkoutForm.find('#billing_postcode');
        this.formCity = this.checkoutForm.find('#billing_city');
        this.formEmail = this.checkoutForm.find('#billing_email');
        this.phoneNumber = this.checkoutForm.find('#billing_phone');

        this.nexBtnFirstCol.on('click', e => {
            e.preventDefault();
            let valid = true;

            $.each([this.formName, this.formLastName, this.formAddress, this.formPostCode, this.formCity, this.phoneNumber], function(i, formItem) {
                if (formItem.val().trim() === '') {
                    formItem.parent().addClass('is-invalid');
                    formItem.one('keyup', function () {
                        return formItem.parent().removeClass('is-invalid');
                    });
                    valid = false;
                }
            });

            if (this.formEmail.val().trim() === '' || this.formEmail.val().indexOf('@') === -1) {
                this.formEmail.parent().addClass('is-invalid');
                this.formEmail.one('keyup', () => this.formEmail.parent().removeClass('is-invalid'));
                valid = false;
            }

            if (valid) {
                this.checkoutGridFirstCol.addClass('is-hidden');
                this.checkoutGridSecondCol.addClass('is-step-2');
            }
        });

        this.nexBtnFirstCol.one('click', () => {
            this.backBtnToStep2 = this.checkoutForm.find('.woocommerce-checkout-payment .back-to-step-2');
            this.backBtnToStep2.on('click', e => {
                e.preventDefault();
                this.checkoutGridSecondCol.removeClass('is-step-3');
                this.checkoutGridSecondCol.addClass('is-step-2');
            });
            this.gtmSendStep2Data();
        });
    }

    generateSummary () {
        let shippingDeliveryCheckbox = $('#ship-to-different-address-checkbox');
        let output = $('<div class="summary-data"></div>');
        let outputCol1 = $('<div class="summary-data-col summary-data-col1"><h4 class="summary-data-title">Dane zamawiającego</h4><div class="summary-data-content"></div></div>');
        let outputCol3 = $('<div class="summary-data-col summary-data-col3"><h4 class="summary-data-title-payment">Metoda płatności</h4><div class="summary-data-content-payment"></div><h4 class="summary-data-title-shipping">Metoda wysyłki</h4><div class="summary-data-content-shipping"></div></div>');
        let billingName = $('input[name="billing_first_name"]').val();
        let billingLastName = $('input[name="billing_last_name"]').val();
        let billingStreet1 = $('input[name="billing_address_1"]').val();
        let billingStreet2 = $('input[name="billing_address_2"]').val();
        let billingPostCode = $('input[name="billing_postcode"]').val();
        let billingCity = $('input[name="billing_city"]').val();

        let shippingName = $('input[name="shipping_first_name"]').val();
        let shippingLastName = $('input[name="shipping_last_name"]').val();
        let shippingStreet1 = $('input[name="shipping_address_1"]').val();
        let shippingStreet2 = $('input[name="shipping_address_2"]').val();
        let shippingPostCode = $('input[name="shipping_postcode"]').val();
        let shippingCity = $('input[name="shipping_city"]').val();

        outputCol1.find('.summary-data-content').text(billingName + ' ' + billingLastName + ', ul.' + billingStreet1 + ' ' + billingStreet2 + ', ' + billingPostCode + ' ' + billingCity);

        let selectedDeliveryMethod = $('input[name="shipping_method[0]"]:checked').val();
        let deliveryMethod = $('#shipping_method label').filter((i, label) => $(label).attr('for') === 'shipping_method_0_' + selectedDeliveryMethod);

        let selectedPaymentMethod = $('input[name="payment_method"]:checked').val();
        let paymentMethod = $('.wc_payment_methods label').filter((i, label) => $(label).attr('for') === 'payment_method_' + selectedPaymentMethod);

        if (deliveryMethod.length) {
            let currentDeliveryMethod = deliveryMethod.eq(0).text();

            outputCol3.find('.summary-data-content-shipping').text(currentDeliveryMethod);
        }

        if (paymentMethod.length) {
            let currentPaymentMethod = paymentMethod.eq(0).text();

            outputCol3.find('.summary-data-content-payment').text(currentPaymentMethod);
        }

        if(shippingDeliveryCheckbox.attr('checked') === 'checked') {
            let outputCol2 = $('<div class="summary-data-col summary-data-col2"><h4 class="summary-data-title">Dane wysyłki</h4><div class="summary-data-content"></div></div>');
            outputCol2.find('.summary-data-content').text(shippingName + ' ' + shippingLastName + ', ul.' + shippingStreet1 + ' ' + shippingStreet2 + ', ' + shippingPostCode + ' ' + shippingCity);
            output.html(outputCol1[0].outerHTML + outputCol2[0].outerHTML + outputCol3[0].outerHTML);
        } else {
            output.html(outputCol1[0].outerHTML + outputCol3[0].outerHTML);
        }

        return output;
    }

    initGTM () {
        let differentAddressCheckbox = document.querySelector('#ship-to-different-address-checkbox');

        if (differentAddressCheckbox) {
            differentAddressCheckbox.addEventListener('change', function () {
                let optionValue = differentAddressCheckbox.checked ? 'Inny adres' : 'Ten sam adres';

                dataLayer.push({    
                    'event': 'checkoutOption', 
                    'ecommerce': { 
                        'checkout_option': { 
                            'actionField': {
                                'step': 2, 
                                'option': optionValue
                            } 
                        } 
                    } 
                }); 
            }, false);
        }

        $('.woocommerce-checkout .woocommerce-checkout-review-order').on('click', (e) => {            
            if (e.target.tagName === 'INPUT' && e.target.classList.contains('shipping_method')) {
                if (!e.clientX) {
                    return;
                }

                dataLayer.push({    
                    'event': 'checkoutOption', 
                    'ecommerce': { 
                        'checkout_option': { 
                            'actionField': {
                                'step': 3, 
                                'option': $(e.target).next('label').text().trim()
                            } 
                        } 
                    }
                }); 
                return;
            }

            if (e.target.tagName === 'INPUT' && e.target.getAttribute('name') === 'payment_method') {
                if (!e.clientX) {
                    return;
                }

                dataLayer.push({    
                    'event': 'checkoutOption', 
                    'ecommerce': { 
                        'checkout_option': { 
                            'actionField': {
                                'step': 3, 
                                'option': $(e.target).next('label').text().trim()
                            } 
                        } 
                    }
                }); 
                return;
            }

            if (e.target.tagName === 'A' && e.target.classList.contains('next-btn')) {
                this.gtmSendStep3Data();
            }
        });
    }

    gtmSendStep2Data () {
        dataLayer.push({ 
            'pageType': 'checkout', 
            'languageVersion': 'PL', 
            'ecommerce': { 
                'currencyCode': 'PLN', 
                'checkout': { 
                    'actionField': { 
                        'step': 3, 
                        'option': 'dostawa', 
                        'action': 'checkout' 
                    },
                    'products': window.mm_items_in_cart.slice()
                }
            }
        });
    }

    gtmSendStep3Data () {
        dataLayer.push({ 
            'pageType': 'checkout', 
            'languageVersion': 'PL', 
            'delivery': jQuery('input.shipping_method:checked').next('label').text().trim(),
            'paymentMethod': jQuery('input[name="payment_method"]:checked').next('label').text().trim(), 
            'ecommerce': { 
                'currencyCode': 'PLN', 
                'checkout': { 
                    'actionField': { 
                        'step': 4, 
                        'option': 'podsumowanie', 
                        'action': 'checkout' 
                    },
                    'products': window.mm_items_in_cart.slice()
                }
            }
        });
    }
}
